import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paraHead: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  paraSubHead: {
    marginBottom: theme.spacing(4),
  },
  list: {
    marginBottom: theme.spacing(8),
  },
  listItem: {
    fontSize: "20px",
    padding: 0,
    "&::marker": {
      color: theme.palette.info.main,
    },
  },
  readerImg: {
    maxWidth: "100%",
    maxHeight: "400px",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4),
    },
  },
  bankLogo: {
    maxWidth: 100,
    height: 50,
    margin: "1rem",
  },
  conainerLogos: {
    paddingTop: "3rem",
  },
  btnBuy: {
    padding: ".34rem 1.8rem",
  },
}));

export default useStyles;
